import React, { useState, useRef, useImperativeHandle } from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Input, Checkbox, Button, Radio } from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './EditableSelectInput.less';

const { TextArea } = Input;

export const EditableSelectInput = (props) => {
  const [label, setLabel] = useState(props.label);
  const inputEl = useRef(null);

  useImperativeHandle(inputEl, () => ({
    focus: () => {
      inputEl.current.focus();
    },
  }));

  const onBlur = () => {
    const newValue = label.trim();
    if (!newValue || newValue === props.label) {
      setLabel(props.label);
      return;
    }

    props.onSubmit(newValue, props.value);
  };

  const Com = props.type === 'checkbox' ? Checkbox : Radio;
  const disallowEmptyInput = !props.allowEmpty;
  return (
    <Com {...props} className={styles.editableCheckbox}>
      <div
        className={classNames('ant-form-item-control', {
          'has-error': !label && disallowEmptyInput,
        })}
      >
        <TextArea
          autoSize={{ minRows: 1, maxRows: 6 }}
          ref={inputEl}
          placeholder="Insert..."
          onBlur={onBlur}
          onPressEnter={onBlur}
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
        {!label && disallowEmptyInput && (
          <div className="ant-form-explain">The value can not be empty!</div>
        )}
      </div>
      <Button
        onClick={() => props.onRemove(parseInt(props.value, 10))}
        ghost
        type="danger"
        icon={<DeleteOutlined />}
        className="clear-btn"
      />
    </Com>
  );
};

EditableSelectInput.defaultProps = {
  type: 'checkbox',
};

EditableSelectInput.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  allowEmpty: PropTypes.bool,
};
